import { Directive, Input, OnDestroy } from '@angular/core';
import { TitleService } from '../services/page-title.service';

@Directive({
  selector: '[tbPageTitle]',
})
export class PageTitleDirective implements OnDestroy {
  @Input('tbPageTitle') public set pageTitle(title: string) {
    this.titleService.setTitle(title);
  }

  constructor(private titleService: TitleService) {}

  public ngOnDestroy() {
    this.titleService.setTitle(null);
  }
}
